const defaultState = {
  data: [],
  countArr: [0, 0, 0]
}

function listGlassesGroup(state = defaultState, action) {
  switch (action.type) {
    case 'RESET_ALL_GLASSES_STATE':
      return defaultState
    case 'GET_ALL_GLASSES_GROUP_SUCCESS':
      return action.payload
    case 'UPDATE_MODEL_TYPE': {
      const { id, modelType } = action.payload
      const newData = [...state.data]
      const updatedIdx = newData.findIndex(product => product.id === id)
      if (updatedIdx >= 0) {
        newData[updatedIdx].modelType = modelType
      }
      return {
        ...state,
        data: newData
      }
    }
    default:
      return state
  }
}

export default {
  listGlassesGroup
}



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-group/reducer/index.js